import React, { Component } from 'react'
import { pluralize, intComma } from 'humanize-plus'
import IconSVG from 'svg-inline-react'
import cx from 'classnames'
import _isNumber from 'lodash/isNumber'

import MadKuduTag from 'components/shared/MadKuduTag'
import { MadkuduSignalMap, MadkuduLabelMap } from 'app/modules/playbook/constants'

import { SectionHeader, SectionBody } from './style.styl'

import checkmarkSrc from '!svg-inline?removeTags=true!images/svg/check.svg'
import crossSrc from '!svg-inline?removeTags=true!images/svg/redx.svg'
import madKuduLogoSrc from '!svg-inline?removeTags=true!images/svg/madkudu-logo.svg'

const renderSignalValue = (value) => {
  if(value === null) {
    return ''
  }
  const numValue = parseInt(value)

  if(_.isNumber(numValue) && !isNaN(numValue)) {
    return intComma(numValue)
  }
  return value
}

const ScoringSignal = ({ signal }) => {
  return (
    <div key={signal.name} className="madkudu-signal-list-item">
      <IconSVG
        src={signal.type === 'positive' ? checkmarkSrc : crossSrc}
        className={cx('madkudu-dot-icon', signal.type)}
      />{' '}
      {`${MadkuduSignalMap[signal.name] || signal.name} ${renderSignalValue(signal.value)}`}
    </div>
  )
}

export default class ScoringSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAllPositive: false,
      showAllNegative: false,
    }
  }

  renderPlaceholder() {
    return <div className="scoring-section-placeholder" />
  }

  handleShowAllPositive = () => {
    this.setState({
      showAllPositive: true,
    })
  }

  handleShowAllNegative = () => {
    this.setState({
      showAllNegative: true,
    })
  }

  render() {
    if (!this.props.endUser) {
      return this.renderPlaceholder()
    }

    const { showAllPositive, showAllNegative } = this.state
    const { endUser: { attributes }} = this.props

    const kuduScore = attributes.get('_madkudu_score')
    const signalsBlob = attributes.get('_madkudu_signals')

    if (!kuduScore || !signalsBlob) return <div />

    const kuduSignals = JSON.parse(signalsBlob)

    const defaultSliceLength = 5
    const positiveSignals = kuduSignals.filter(signal => signal.type === 'positive')
    const showMorePosCount = positiveSignals.length - defaultSliceLength
    const negativeSignals = kuduSignals.filter(signal => signal.type === 'negative')
    const showMoreNegCount = negativeSignals.length - defaultSliceLength

    const totalSignals = negativeSignals.length + positiveSignals.length
    return (
      <div>
        <div className={SectionHeader}>
          <span>Score</span>
          <IconSVG src={madKuduLogoSrc} className="madkudu-logo" />
        </div>
        <div className={SectionBody}>
          <div className="madkudu-lead-score">
            <MadKuduTag score={kuduScore} />
          </div>
          <div className="madkudu-lead-narrative">
            This lead is <strong>{MadkuduLabelMap[kuduScore]}</strong> based on{' '}
            {positiveSignals.length} positive and {negativeSignals.length} negative{' '}
            {totalSignals < 2 && negativeSignals.length === 1 ? (
              'signal'
            ) : (
              pluralize(totalSignals, 'signal')
            )}.
          </div>
          <div className="madkudu-signal-list">
            {positiveSignals
              .slice(0, showAllPositive ? 100 : defaultSliceLength)
              .map((signal, index) => <ScoringSignal key={index} signal={signal} />)}
            {!showAllPositive &&
            showMorePosCount > 0 && (
              <p className="show-more-signals" onClick={this.handleShowAllPositive}>
                show {showMorePosCount} more...
              </p>
            )}
            {negativeSignals
              .slice(0, showAllNegative ? 100 : defaultSliceLength)
              .map((signal, index) => <ScoringSignal key={index} signal={signal} />)}
            {!showAllPositive &&
            showMoreNegCount > 0 && (
              <p className="show-more-signals" onClick={this.handleShowAllNegative}>
                show {showMoreNegCount} more...
              </p>
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/ScoringSection/index.js